import { createSvgIcon } from '@mui/material';

const LIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.973"
    height="20.395"
    viewBox="0 0 15.973 20.395"
  >
    <g id="Group_3005" data-name="Group 3005" transform="translate(-1162.008 -508.363)">
      <rect
        id="Rectangle_2606"
        data-name="Rectangle 2606"
        width="9.714"
        height="8.772"
        rx="1"
        transform="translate(1165.152 509.122)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <rect
        id="Rectangle_2607"
        data-name="Rectangle 2607"
        width="14.473"
        height="10.114"
        rx="1"
        transform="translate(1162.758 517.894)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_2821"
        data-name="Path 2821"
        d="M1188.078,512.271l-1.5-1.236-1.417,1.236v-5.158h2.914Z"
        transform="translate(-16.333 2)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_2822"
        data-name="Path 2822"
        d="M1188.078,544.742l-1.5-1.236-1.417,1.236v-5.148h2.914Z"
        transform="translate(-16.333 -21.669)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </g>
  </svg>,
  'LIcon',
);

export default LIcon;
